export class StatusConstant {
    static STATUS_EMPTY_ID = "EMPTY";
    static STATUS_FILLED_ID = "FILLED";
  
    static MANIFESTO_STATUS_OPTIONS = [
      { label: "Vide", value: this.STATUS_EMPTY_ID },
      { label: "Plein", value: this.STATUS_FILLED_ID },
    ];
  }
  
  export const getStatusTagData = (id: string) => {
    const option = StatusConstant.MANIFESTO_STATUS_OPTIONS.find(
      (opt) => opt.value === id
    );
    let color = "default";
    switch (id) {
      case StatusConstant.STATUS_EMPTY_ID:
        color = "red";
        break;
      case StatusConstant.STATUS_FILLED_ID:
        color = "green";
        break;
    }
    return { label: option?.label || id, color };
  };
  